// social — Bloom's own pages elsewhere, from /api/bloom/social (property co.obto.bloom.social).
// Nothing shows until the owner sets a link, so a new page needs no rebuild. B14: the WhatsApp
// channel, in the footer and in the "Keep Bloom close" band.
import React, { useEffect, useState } from "react";
import { useMessages } from "./messages";

export type Social = { whatsapp?: string };

let pending: Promise<Social> | null = null;

function load(): Promise<Social> {
    if (!pending) {
        pending = fetch("/api/bloom/social")
            .then((r) => (r.ok ? r.json() : null))
            .then((d) => (d && d.links && typeof d.links === "object" ? (d.links as Social) : {}))
            .catch(() => ({}));
    }
    return pending;
}

export function useSocial(): Social {
    const [links, setLinks] = useState<Social>({});
    useEffect(() => {
        let live = true;
        load().then((v) => { if (live) setLinks(v); });
        return () => { live = false; };
    }, []);
    return links;
}

export function ChatIcon({ className }: { className?: string }) {
    return (
        <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3.5 20.5l1.4-4.1A8.5 8.5 0 1 1 8.1 19.2z" />
            <path d="M8.5 10.5h7M8.5 13.5h4.5" />
        </svg>
    );
}

// Footer line: "Join our WhatsApp channel".
export function ChannelLink() {
    const m = useMessages();
    const { whatsapp } = useSocial();
    if (!whatsapp) return null;
    return (
        <p className="mb-2">
            <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 font-semibold text-green-700 hover:underline">
                <ChatIcon className="h-4 w-4" />
                {m.waJoin}
            </a>
        </p>
    );
}
